import React from 'react';

export default function DatabaseError({ message, onRetry }) {
  if (!message) return null;
  return (
    <div className="mb-5 rounded-2xl border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-800">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-bold">Database connection needs attention</p>
          <p className="mt-1">
            {message}
          </p>
          <p className="mt-1 text-xs text-red-700">
            Your records are not deleted. The admin panel could not read Firestore with the current browser session.
          </p>
        </div>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="shrink-0 rounded-lg bg-white px-3 py-1.5 text-xs font-semibold text-red-700 shadow-sm hover:bg-red-100"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
